import React from "react";
import PortalCard from "./PortalCard";
import Footer from "../../shared/Footer";
import "../../styles/portal.css";

// Page chrome for the platform legal pages (src/pages/legal/*). Pages supply
// only their title and copy; headings, paragraphs and lists inside the card are
// styled by the `.portal-legal` rules in portal.css.
export default function LegalLayout({ title, updated, children }) {
  return (
    <div style={pageStyle}>
      <div style={heroBannerStyle}>
        <div style={heroContentStyle}>
          <h1 style={heroTitleStyle}>{title}</h1>
          {updated && <p style={heroSubheadStyle}>{updated}</p>}
        </div>
      </div>

      <div style={pageBodyStyle}>
        <PortalCard variant="default" style={cardOverrideStyle}>
          <div className="portal-legal">{children}</div>
        </PortalCard>
      </div>
      <Footer style={{ marginTop: 0 }} />
    </div>
  );
}

const pageStyle = {
  width: "100%",
  margin: 0,
  padding: 0,
  overflowX: "hidden",
  backgroundColor: "#f4f7fb",
  minHeight: "100vh",
};

const heroBannerStyle = {
  backgroundColor: "#0d1b2a",
  padding: "64px 16px",
};

const heroContentStyle = {
  maxWidth: "860px",
  margin: "0 auto",
};

const heroTitleStyle = {
  color: "#ffffff",
  fontWeight: 700,
  fontSize: "2.5rem",
  margin: "0 0 0.4rem 0",
};

const heroSubheadStyle = {
  color: "#43c6f9",
  fontSize: "1.1rem",
  margin: 0,
};

const pageBodyStyle = {
  maxWidth: "860px",
  margin: "0 auto",
  padding: "32px 16px 24px",
};

const cardOverrideStyle = {
  marginBottom: "24px",
  padding: "2rem",
};
